import {
  HyphenIcon,
  OverflowText,
  TextTooltip,
} from "@transfr-inc/dashboard-components";
import {
  BasicCell,
  Column,
  ColumnOptions,
  ColumnType,
} from "@transfr-inc/dashboard-components/data-table";

import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";
import { getContentTypeById } from "@transfr-inc/dashboard-components/curriculum";
import StatusBadge from "./status-badge";

export const libraryColumns = (type, openActivityOrgsModal) => {
  if (type === "Activities") {
    return [
      LibraryColumnDefinition.NAME,
      LibraryColumnDefinition.DESCRIPTION,
      LibraryColumnDefinition.CREATED,
      LibraryColumnDefinition.LAST_UPDATED,
      LibraryColumnDefinition.AUTHOR,
      LibraryColumnDefinition.ORGS(openActivityOrgsModal),
      LibraryColumnDefinition.TYPE,
      LibraryColumnDefinition.STATUS,
    ];
  }
  return [];
};

export const LibraryColumnDefinition = {
  NAME: new Column(
    "title",
    "Name",
    ColumnType.BASIC,
    new ColumnOptions({
      sortingEnabled: true,
      overflowEnabled: true,
    }),
  ),
  DESCRIPTION: new Column(
    "description",
    "Description",
    ColumnType.BASIC,
    new ColumnOptions({
      sortingEnabled: true,
      overflowEnabled: true,
    }),
  ),
  CREATED: new Column(
    "created",
    "Created",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: true,
      overflowEnabled: true,
      customFunction: (_value, row) => {
        const dateCreated = row.date_created || row.created;
        const formattedDate = dateCreated
          ? formatDateDigits(dateCreated)
          : undefined;
        return <BasicCell value={formattedDate}></BasicCell>;
      },
    }),
  ),
  LAST_UPDATED: new Column(
    "lastUpdated",
    "Last Updated",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: true,
      overflowEnabled: true,
      customFunction: (_value, row) => {
        const dateLastUpdated = row.lastUpdated || row.created;
        const formattedDate = dateLastUpdated
          ? formatDateDigits(dateLastUpdated)
          : undefined;
        return <BasicCell value={formattedDate}></BasicCell>;
      },
    }),
  ),
  AUTHOR: new Column(
    "author",
    "Author",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: false,
      customFunction: (_value, row) => {
        const name = _value?.firstName ? (
          `${_value?.firstName} ${_value?.lastName}`
        ) : (
          <HyphenIcon />
        );
        return <div className="activities-cell">{name}</div>;
      },
      sortKeyFields: ["author"],
    }),
  ),
  ORGS: (openActivityOrgsModal) => {
    return new Column(
      "organizations",
      "Orgs",
      ColumnType.CUSTOM,
      Object.assign(
        new ColumnOptions({
          sortingEnabled: true,
          customFunction: (_value, row) => {
            if (row.organizations.length === 0) {
              return (
                <div className="activities-cell activities-cell-navy">
                  <HyphenIcon />
                </div>
              );
            }
            if (row.organizations.length <= 10) {
              const tooltipText = row.organizations
                .map(({ name }) => name)
                .join("<br/>");
              return (
                <TextTooltip className="info" text={tooltipText}>
                  <div className="activities-cell activities-cell-navy activities-cell-underline">
                    {row.organizations.length}
                  </div>
                </TextTooltip>
              );
            }
            return (
              <div
                className="activities-cell activities-cell-navy activities-cell-underline activities-cell-clickable"
                onClick={
                  openActivityOrgsModal && (() => openActivityOrgsModal(row))
                }
              >
                {row.organizations.length}
              </div>
            );
          },
          sortKeyFunctions: [(row) => row.organizations.length],
        }),
      ),
    );
  },
  TYPE: new Column(
    "contentType",
    "Type",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: false,
      overflowEnabled: true,
      customFunction: (_value, row) => {
        const name = getContentTypeById(_value)?.label;
        return <OverflowText text={name}>{name}</OverflowText>;
      },
      sortKeyFields: ["author"],
    }),
  ),
  STATUS: new Column(
    "status",
    "Status",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: true,
      overflowEnabled: true,
      customFunction: (_value, row) => {
        return (
          <div className="activities-cell">
            <StatusBadge activityData={row} />
          </div>
        );
      },
    }),
  ),
};
